export const getDisplayUserName = (user) => {
  const displayName = user ? user?.full_name : 'Unknown User';

  if (user?.status === 'inactive') {
    return (
      <>
        {displayName}{' '}
        <span
          style={{ fontSize: '0.8em', color: 'gray', fontWeight: 'normal' }}>
          (Inactive)
        </span>
      </>
    );
  }

  return displayName;
};

export const showUserDisplayName = (userId, users) => {
  if (userId) {
    const user = users?.find((user) => user?.id === userId);
    return getDisplayUserName(user || null);
  } else {
    return null;
  }
};

export const renderUserOptions = (users) => {
  return users?.map((user) => (
    <option key={user?.id} value={user?.id} disabled={user?.status === "inactive"}>
      {getDisplayUserName(user)}
    </option>
  ));
};

export const isExecutiveManager = () => {
  try {
    const userRole = JSON.parse(localStorage.getItem('role'));
    return userRole === 'executive-manager';
  } catch (err) {
    return false;
  }
};

export const isAdminUser = (type = 'all-admins') => {
  try {
    const userRole = JSON.parse(localStorage.getItem('role'));

    const roleGroups = {
      'all-admins': ['org-admin', 'org-manager', 'project-admin', 'admin'],
      'only-org': ['org-admin', 'org-manager'],
      'only-project': ['project-admin', 'admin'],
    };

    return roleGroups[type]?.includes(userRole) || false;
  } catch (err) {
    return false;
  }
};
